export const enum FacebookMediaModeEnum {
    Unspecified = 'unspecified',
    Video = 'video',
    Images = 'image',
}
